import { useFormikContext } from 'formik';
import { useEffect } from 'react';

const FormValidationError = ({ onError = () => {} }) => {
  const { isValid, isSubmitting, errors } = useFormikContext();

  useEffect(() => {
    if (!isValid && isSubmitting) {
      onError(errors);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitting, isValid]);

  return <></>;
};

export default FormValidationError;
